import { Link, useLocation } from "react-router-dom";
import { comicCategories, getComicById } from "@/mocks/comicData";
import { useMemo } from "react";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb() {
  const location = useLocation();

  const items = useMemo(() => {
    const crumbs: BreadcrumbItem[] = [{ label: "首页", href: "/" }];
    const pathParts = location.pathname.split("/").filter(Boolean);

    if (pathParts[0] === "category" && pathParts[1]) {
      const cat = comicCategories.find((c) => c.slug === pathParts[1]);
      crumbs.push({ label: "漫画分类", href: "/category/all" });
      if (cat) {
        crumbs.push({ label: cat.name });
      }
    }

    if (pathParts[0] === "article" && pathParts[1]) {
      crumbs.push({ label: "漫画分类", href: "/category/all" });
      const comic = getComicById(pathParts[1]);
      if (comic) {
        crumbs.push({ label: comic.title });
      } else {
        crumbs.push({ label: "漫画详情" });
      }
    }

    if (pathParts[0] === "about") {
      crumbs.push({ label: "关于我们" });
    }

    return crumbs;
  }, [location.pathname]);

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <span className="text-foreground-400">/</span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}